import {
  Component,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { NgClass } from '@angular/common';
// Third Party
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
// Models
import { Answers, Questions } from '../../models/constants';
import { YesNoResponse } from '../../models/general';
// Services
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-yes-no',
  templateUrl: './yes-no.component.html',
  styleUrls: ['./yes-no.component.scss'],
  standalone: true,
  imports: [NgClass],
})
export class YesNoComponent implements OnDestroy {
  @ViewChild('yes_no_modal', { static: false }) yes_no_modal: TemplateRef<any>;
  public readonly Questions = Questions;

  @Input() context: any;
  question: string;
  optional_details: {};
  modal_id: number;
  reverse_btn_color: boolean = false; // change the color of the buttons based on the this var. still needs to be coded

  modalRef: BsModalRef;
  modalConfig = {
    animated: true,
  };

  yn_options: ModalOptions = {
    class: 'modal-dialog, modal-dialog-centered',
    backdrop: 'static',
    ignoreBackdropClick: true,
    keyboard: false,
  };

  constructor(
    protected element: ElementRef,
    private modalService: BsModalService,
    private sharedService: SharedService,
  ) {}

  ngOnInit(): void {
    this.modal_id = this.modalService.config.id as number;
    if ('ffl' in this.optional_details) {
      if (!this.optional_details['ffl'].toString().includes('-')) {
        this.optional_details['ffl'] = this.formatFfl(
          this.optional_details['ffl'].toString(),
        );
      }
    }
  }

  // Closes the Modal
  closeModal() {
    this.modalService.hide(this.modal_id);
  }

  // function used if the "Yes" button is pressed
  yesClick() {
    let response: YesNoResponse = new YesNoResponse();
    response.answer = Answers.yes;
    response.optional_details = this.optional_details;
    response.question = this.question;
    this.sharedService.yes_no_submit$.next(response);
    this.closeModal();
  }

  // function used if the "No" button is pressed
  noClick() {
    let response: YesNoResponse = new YesNoResponse();
    response.answer = Answers.no;
    response.optional_details = this.optional_details;
    response.question = this.question;
    this.sharedService.yes_no_submit$.next(response);
    this.closeModal();
  }

  ngOnDestroy() {
    //    this.sub.unsubscribe();
  }
  formatFfl(ffl: string): string {
    let formattedFfl = ffl;
    formattedFfl =
      ffl.substring(0, 1) +
      '-' +
      ffl.substring(1, 3) +
      '-' +
      ffl.substring(3, 6) +
      '-' +
      ffl.substring(6, 8) +
      '-' +
      ffl.substring(8, 10) +
      '-' +
      ffl.substring(10, 15);
    return formattedFfl;
  }
}
